// Dựng đối số cho fs.symlink() theo platform — tách thành hàm thuần để test được
// hành vi Windows trên máy POSIX (không có CI Windows).
//
// v3.19.4 FIX: symlink farm gọi `fs.symlink(relativeSource, dest)` không truyền
// `type`. Trên Windows, Node autodetect target là thư mục → tạo symlink kiểu 'dir',
// mà loại này đòi quyền SeCreateSymbolicLinkPrivilege (Developer Mode hoặc chạy
// Administrator). User thường → EPERM → `avatar sync` không dựng nổi mount dir.
//
// Junction (NTFS reparse point trỏ thư mục) KHÔNG đòi đặc quyền — đây là cách npm
// dùng để link trên Windows.
//
// ⚠️ BẪY đi kèm: junction BẮT BUỘC target tuyệt đối. Nếu truyền path tương đối,
// Node tự chuẩn hoá thành tuyệt đối THEO CWD — trong khi path tương đối của symlink
// farm neo theo `dirname(dest)`. CWD ≠ dirname(dest) ⇒ junction trỏ sai chỗ mà
// KHÔNG báo lỗi. Vì vậy nhánh win32 phải resolve target tuyệt đối trước.
//
// POSIX giữ NGUYÊN hành vi cũ: target tương đối theo dirname(dest), không type.
import nodePath from "node:path";
import type { HostPlatform } from "./detect-host-platform.js";

/** Tập con API node:path mà helper cần — `path.win32` / `path.posix` đều thoả. */
export type PathImpl = Pick<typeof nodePath, "relative" | "resolve" | "dirname">;

export interface SymlinkArgs {
  /** Đối số 1 của fs.symlink (target). */
  target: string;
  /** Đối số 3 của fs.symlink — chỉ có nghĩa trên Windows, POSIX bỏ qua. */
  type?: "junction";
}

/**
 * Trả về { target, type } để gọi `fs.symlink(target, dest, type)`.
 *
 * Windows → junction + target TUYỆT ĐỐI (không cần đặc quyền, tránh bẫy CWD).
 * Còn lại → target TƯƠNG ĐỐI theo dirname(dest), không type (hành vi cũ, giữ nguyên).
 */
export function buildSymlinkArgsForPlatform(
  source: string,
  dest: string,
  platform: HostPlatform,
  p: PathImpl = nodePath,
): SymlinkArgs {
  if (platform === "win32") {
    return { target: p.resolve(source), type: "junction" };
  }
  return { target: p.relative(p.dirname(dest), source) };
}
